import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import React from "react";

export function PackageChangeConfirmationDialog(props: { onClose(): void; onConfirm(): void }) {
  return (
    <Dialog open onClose={props.onClose}>
      <DialogTitle>Zastąp konfigurację pakietu</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Zmieniłeś pakiet źródłowy. Czy na pewno chcesz wczytać nowy pakiet? Obecne elementy w kalkulacji zostaną
          usunięte i zastąpione konfiguracją nowego pakietu.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose} color="inherit">
          Anuluj
        </Button>
        <Button onClick={props.onConfirm} color="primary" variant="contained" disableElevation>
          Tak, zmień pakiet
        </Button>
      </DialogActions>
    </Dialog>
  );
}
